export type TTableState = Record<string, boolean>;

export const findSomeRowsAreDirty = (state: TTableState) =>
  Object.values(state).some((stateItem) => stateItem);
